import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import {BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {Link} from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ImageList from '@mui/material/ImageList';
import {BottomMenu,BackButton} from './HookUtils'
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import {BasketComponent} from "./BasketComponent";

export class AllProductComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            productList: [],
        }
    }

    componentDidMount() {
        fetch(BASE_URL_API + 'product?market_id=' + this.props.market_id + '&child_category_id=' + this.props.child_category_id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    // Sort products: those with pictures first
                    const sortedProducts = results.data.sort((a, b) => {
                        return (b.pictures.length > 0 ? 1 : 0) - (a.pictures.length > 0 ? 1 : 0);
                    });
                    this.setState({ productList: sortedProducts });
                },
                (error) => {
                    console.log("error")
                }
            );
    }


    render() {

        const MAX_LENGTH = 25;

        return (
            <div>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <ShoppingBasketOutlinedIcon style={{color: 'black'}}/>
                        {
                            this.state.productList.length > 0 ?

                                <ListItemText align="center"><strong style={{
                                    fontSize: 18,
                                    overflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    color: 'black'
                                }} >{this.state.productList[0].category.title}</strong></ListItemText>
                                : ""
                        }

                        <IconButton component={Link} to={"/search"} style={{color: 'black'}} size="large"><SearchIcon/></IconButton>

                        <IconButton style={{color: 'black'}} size="large"> <BasketComponent/></IconButton>

                        <BackButton/>
                    </ToolbarMui>

                </AppBar>
                {
                    <React.Fragment>
                        <div style={{
                            marginTop: 80,
                            marginBottom: 80,
                            padding: 12,
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: 12,
                        }}>
                            {this.state.productList.map((product) => (
                                <div key={product.id} style={{ width: 150 }}>
                                    <Link to={`/product?id=${product.id}`} style={{ textDecoration: "none" }}>
                                        <Paper style={{
                                            width: 150,
                                            height: 140,
                                            backgroundImage: `url(${product.pictures.length > 0 ? PRODUCT_BASE_URL_API + product.pictures[0].url : "hamekara-logo.png"})`,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            borderRadius: 8,
                                        }} />
                                        <p style={{
                                            fontSize: 14,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            color: '#000',
                                            margin: "6px 0",
                                            textAlign: "center"
                                        }}>
                                            {product.title.length > 25 ? product.title.substring(0, 25) + "..." : product.title}
                                        </p>
                                        {product.del_price > 0 ? (
                                            <>
                                                <p style={{
                                                    fontSize: 12,
                                                    color: 'gray',
                                                    textDecoration: 'line-through',
                                                    margin: 0,
                                                    textAlign: "center"
                                                }}>
                                                    {`${product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان`}
                                                </p>
                                                <p style={{
                                                    fontSize: 14,
                                                    color: 'green',
                                                    margin: 0,
                                                    textAlign: "center"
                                                }}>
                                                    {`${(product.price - product.del_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان`}
                                                </p>
                                            </>
                                        ) : (
                                            <p style={{
                                                fontSize: 14,
                                                color: 'green',
                                                margin: 0,
                                                textAlign: "center"
                                            }}>
                                                {product.price > 0
                                                    ? `${product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان`
                                                    : "تماس بگیرید."}
                                            </p>
                                        )}
                                    </Link>
                                </div>
                            ))}
                        </div>

                        <BottomMenu />
                    </React.Fragment>

                }
            </div>
        );

    }

}
